module.exports = __webpack_public_path__ + "img/boxTitleBgc.12a9df2c.png";